import {NoteLinkedObjectType, NotePartType} from 'notebook/util/NoteUtilConstants';
import notifications, {NotificationType} from 'notifications';

export const DEFAULT_CONTENT_SUMMARY = 'New content';

// Keep in sync with benchling/notebook/document_update_summary.py
export enum DocumentUpdateType {
  INSERTING = 'inserting',
  APPENDING = 'appending',
  INSERTED = 'inserted',
  APPENDED = 'appended',
}

export type DocumentContentType = NoteLinkedObjectType | NotePartType;

export interface DocumentUpdateNotification {
  updateType: DocumentUpdateType;
  contentTypes: Array<DocumentContentType>;
  notificationType: NotificationType;
}

const CONTENT_TYPE_GLOSSARY: Partial<{[contentType in DocumentContentType]: string}> = {
  [NoteLinkedObjectType.NOTE_LINKED_CHART]: 'A chart',
  [NotePartType.TEXT]: 'Text content',
};

const UPDATE_MESSAGE_GLOSSARY: {[updateType in DocumentUpdateType]: string} = {
  [DocumentUpdateType.INSERTING]: 'is being inserted into the document.',
  [DocumentUpdateType.APPENDING]: 'is being appended to the document.',
  [DocumentUpdateType.INSERTED]: 'has been inserted into the document.',
  [DocumentUpdateType.APPENDED]: 'has been appended to the document.',
};

const NOTIFICATION_FUNCTIONS: {[notificationType in NotificationType]: () => (message: string) => void} = {
  [NotificationType.INFO]: () => notifications.info,
  [NotificationType.SUCCESS]: () => notifications.success,
  [NotificationType.WARNING]: () => notifications.warn,
  [NotificationType.DANGER]: () => notifications.error,
};

function describe(contentType: DocumentContentType): string {
  return CONTENT_TYPE_GLOSSARY[contentType] || DEFAULT_CONTENT_SUMMARY;
}

function summarize(updateType: DocumentUpdateType, contentTypes: Array<DocumentContentType>): string {
  const contentSummary = contentTypes.length === 1 ? describe(contentTypes[0]) : DEFAULT_CONTENT_SUMMARY;
  const updateSummary = UPDATE_MESSAGE_GLOSSARY[updateType];
  return `${contentSummary} ${updateSummary}`;
}

export const displayNotification = ({
  updateType,
  contentTypes,
  notificationType,
}: DocumentUpdateNotification): void => {
  NOTIFICATION_FUNCTIONS[notificationType]()(summarize(updateType, contentTypes));
};
